














import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator'
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue'
import ContractItem from '../../../../../domain/contract/entity/contract-item.entity'

@Component({
  components: {
    VbTooltipSlot,
  },
})
export default class EditObservationButton extends Vue {
  @Prop({ required: true })
  item!: ContractItem;

  @Prop()
  disable!: boolean

  get disabled(): boolean {
    return !this.item.isMonthly;
  }

  @Emit('click')
  private click(): void {}
}
